export const Urls = {
    GetReports: "Reports/GetReports",
    IsCompanyReportPurchased: "Reports/IsCompanyReportPurchased",
    GetAllReports: "Reports/GetAllReports",
    GetCustomerReports: "Reports/GetCustomerReports",
    SaveCustomerReports: "Reports/SaveCustomerReports",
    GetFullReportName: "Reports/GetFullReportName",
    GetReportIdByGuid: "Reports/GetReportIdByGuid",
    IsCompanyReportActiveSubscription: "Reports/IsCompanyReportActiveSubscription",
};

export const ReportGuids = {
    GhgRatingChangeReportGuid: '585E45EA-7205-493D-8DC4-2C3DBCA6EBF5'
}